import jQuery from 'jquery'
import select2 from 'select2'
import railsUjs from 'rails-ujs'

window.$ = jQuery
window.jQuery = jQuery

import 'trix'
import 'trix/dist/trix.css'
import 'select2/dist/css/select2.css'

import '../../stylesheets/admin/application.scss'

import './components/admin-tabs'
import './components/color-field'
import './components/counter'
import './components/dashboard-chart'
import './components/flash-snackbar'
import './components/form-spoiler'
import './components/geomarketing'
import './components/image-upload'
import './components/navbar'
import './components/power-supply'
import './components/publication-status'
import './components/sidebar'
import './components/toc-editor'

import './views/affiliate-edit'
import './views/affiliate-show'
import './views/affiliate-statistics'
import './views/author-edit'
import './views/auto-apply-job'
import './views/blog'
import './views/blog-post'
import './views/category-edit'
import './views/dashboard'
import './views/employee-edit'
import './views/example-category-edit'
import './views/example-post'
import './views/export-import-country'
import './views/job-card-show'
import './views/payment-plan-edit'
import './views/payment-scenario-edit'
import './views/template-category-edit'
import './views/templates'

import './shared'
import './email-preview'
import './search-filters'
import './blog-form'
import './users'
import './affiliates'
import './affiliate_applications'
import './partners'
import './cp-contents'
import './cp-second-levels'
import './login'
import './secret'
import './employees'
import './error_form_output'

// Initialize rails-ujs and select2
railsUjs.start()
select2(jQuery)
